import { IonLabel, IonSegment, IonSegmentButton, IonSegmentContent, IonSegmentView } from '@ionic/react';
import PickupIcon from '../../assets/icons/PickupIcon';
import DeliveryIcon from '../../assets/icons/DeliveryIcon';
import PickupSegmentContent from './SegmentContents/PickupSegmentContent';
import ModalWrapper from '../../components/modals/ModalWrapper';
import { ORDER_METHODS } from '../../../../services/exports/Constants';
import DeliverySegmentContent from './SegmentContents/DeliverySegmentContent';
import useOrderMethodModal from './useOrderMethodModal';
import useModalRouter from '../../common/hooks/useModalRouter';
import { ReactElement, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../../components/buttons/Button';
import { IModal } from '../../router/ModalRouter';

const pickupId = ORDER_METHODS.PICKUP;
const deliveryId = ORDER_METHODS.DELIVERY;
const segmentButtons = [
  {
    title: 'titles.pickup',
    id: pickupId,
    icon: <PickupIcon />,
  },
  {
    title: 'titles.delivery',
    id: deliveryId,
    icon: <DeliveryIcon />,
  },
];

interface OrderMethodModalProps extends IModal {
  scheduledForError?: string;
  deliveryAddressError?: string;
}

const OrderMethodModal = (props: OrderMethodModalProps): ReactElement => {
  const { openModal, isOpen } = useModalRouter();
  const { orderMethod, segmentRef, onSegmentChange, onConfirmClick, isConfirmBtnDisabled, validationError } =
    useOrderMethodModal(props);
  const { t } = useTranslation(null, {
    keyPrefix: 'Modules:Mobile:Modals:OrderMethod:OrderMethodModal',
  });
  const scheduledForError = validationError?.scheduledFor ?? props.scheduledForError;
  const deliveryAddressError = validationError?.deliveryAddress ?? props.deliveryAddressError;

  useLayoutEffect(() => {
    if (segmentRef.current) {
      const timeout = setTimeout(() => {
        // @ts-expect-error - updateSegmentView is not in the type definition
        segmentRef.current.updateSegmentView();
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [segmentRef.current, orderMethod, isOpen]);

  return (
    <>
      <ModalWrapper className="mt-4">
        <div className="px-4 border-b-xs pb-4">
          <IonSegment ref={segmentRef} value={orderMethod} className="p-1 rounded-[30px]" onIonChange={onSegmentChange}>
            {segmentButtons.map(({ title, id, icon }) => (
              <IonSegmentButton
                key={id}
                value={id}
                contentId={id}
                layout="icon-start"
                className="space-x-2 [&::part(indicator-background)]:!bg-brand-primary [&::part(indicator-background)]:rounded-[30px] text-gray-700 [&.segment-button-checked]:text-white stroke-mobile-tertiary [&.segment-button-checked]:stroke-white"
              >
                {icon}
                <IonLabel>{t(title)}</IonLabel>
              </IonSegmentButton>
            ))}
          </IonSegment>
        </div>
        <IonSegmentView>
          <IonSegmentContent id={pickupId} key={pickupId}>
            <PickupSegmentContent onClick={(id) => openModal({ id })} scheduledForError={scheduledForError} />
          </IonSegmentContent>
          <IonSegmentContent id={deliveryId} key={deliveryId}>
            <DeliverySegmentContent
              onClick={(id) => openModal({ id })}
              scheduledForError={scheduledForError}
              deliveryAddressError={deliveryAddressError}
            />
          </IonSegmentContent>
        </IonSegmentView>
        <Button
          className="px-md"
          title={t('buttons.confirm')}
          onClick={onConfirmClick}
          disabled={isConfirmBtnDisabled}
        />
      </ModalWrapper>
    </>
  );
};

export default OrderMethodModal;
